
!function(e){"function"!=typeof e.matches&&(e.matches=e.msMatchesSelector||e.mozMatchesSelector||e.webkitMatchesSelector||function(e){for(var t=this,o=(t.document||t.ownerDocument).querySelectorAll(e),n=0;o[n]&&o[n]!==t;)++n;return Boolean(o[n])}),"function"!=typeof e.closest&&(e.closest=function(e){for(var t=this;t&&1===t.nodeType;){if(t.matches(e))return t;t=t.parentNode}return null})}(window.Element.prototype);
document.addEventListener('DOMContentLoaded', function() {
   var modalButtons = document.querySelectorAll('.js-open-modal'),
       overlay      = document.querySelector('.js-overlay-modal'),
       modalOpen = document.querySelectorAll('.b-additional__show'),
       closeButtons = document.querySelectorAll('.js-modal-close');
       var overlayOpen = false;

    for (var i = 0, len = modalButtons.length; i < len; i++) {
        modalButtons[i].addEventListener('click', function(e) {
            e.preventDefault();
            for (var i = 0, len =  modalOpen.length; i < len; i++) {
                modalOpen[i].classList.remove('active');
            }

            var modalId = this.getAttribute('data-modal'),
            modalElem = document.querySelector('.modal[data-modal="' + modalId + '"]');
           
            modalElem.classList.toggle('active');
            if(overlay) {
              overlay.classList.toggle('active');
            }
            this.classList.toggle('active');
        });
    }

    for (var i = 0, len = closeButtons.length; i < len; i++) {
        closeButtons[i].addEventListener('click', function(e) {
        e.preventDefault();
         var mod = document.querySelector('.modal.active');
         mod.classList.remove('active');
         if(overlay) {
            overlay.classList.remove('active');
         }
      });
    }

    document.body.addEventListener('keyup', function (e) {
        var key = e.keyCode;
        if (key == 27) {
            document.querySelector('.modal.active').classList.remove('active');
                this.classList.remove('active');
                overlay.classList.remove('active');
                modalButtons.forEach(function(item){
                item.classList.remove('active');
            });
        };
    }, false);

    if(overlay) {
        overlay.addEventListener('click', function() {
            document.querySelector('.modal.active').classList.remove('active');
            this.classList.remove('active');
            for (var i = 0, len = modalButtons.length; i < len; i++) {
                modalButtons[i].classList.remove('active');
            }
        });
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/event-list/popup.js